module.exports = __webpack_public_path__ + "static/media/about-us-icon.69e266e8.svg";